import { SKILL_NAMES } from 'js/src/agent/skills/skillNames';
import { TOOL_NAMES } from 'js/src/agent/toolNames';
import type { Skill } from '../types';

export const editVideoDuration: Skill = {
    name: SKILL_NAMES.editVideoDuration,
    description:
        'The user wants the video shorter or longer. Load BEFORE making duration or pacing changes.',
    kind: 'howto',
    surfaces: ['sketch'],
    get instructions(): string {
        return `The user may commonly ask to make the video shorter or longer. This is an inherently ambiguous ask.

1. Determine the direction of the change. Are we making the video longer, or shorter?

2. Determine the magnitude of the change. Are we making it just a bit longer/shorter? Or substantially so?

3. (a) If the user is asking for something much longer, we should make sure we know what we’re adding. The user either wants more content (more detail) or potentially to slow down the pace of the video dramatically (split into more scenes, more time per scene, etc)
3. (b) If the user wants something much shorter we’ll need to understand what they want to cut out/focus on.
3. (c) If the user is asking for something slightly longer or shorter, we have a couple knobs. For text videos (or parts of videos), we can adjust the scene duration. For AI voiceover scene groups, we can adjust the AI voiceover speed. For talking-head and recorded-voiceover groups, the recording's own length is fixed, but you can keep just a section of it with ${TOOL_NAMES.trimSceneGroup} (pass the transcript words to keep; the rest is discarded), and you can still adjust the surrounding text scenes. Do NOT fake a trim with ${TOOL_NAMES.splitSceneGroup} or scene deletion.

4. Think carefully about which options make the most sense to achieve the desired result, and then rank those options.

5. Ask the user using the \`${TOOL_NAMES.askUserQuestion}\` tool (unless you are sure you understand their desired outcome). Rank the questions from best to worst - the most naive option should not be the first option.
Do not include low ranking, bad ideas when asking the user. For example, should i make everything 3x as fast is a bad idea and it will annoy the user.`;
    },
};
